module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.booking_number ||
        _vm.Filter.container_number ||
        _vm.Filter.clientFilter ||
        _vm.Filter.slineFilter ||
        _vm.Filter.search_txt ||
        _vm.Filter.createdByFilter ||
        _vm.Filter.branchFilter ||
        _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ||
        _vm.Filter.StatusVerbose ||
        _vm.Filter.hasDateMismatch ||
        _vm.Filter.daysFilter ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.booking_number ||
    _vm.Filter.container_number ||
    _vm.Filter.clientFilter ||
    _vm.Filter.slineFilter ||
    _vm.Filter.search_txt ||
    _vm.Filter.createdByFilter ||
    _vm.Filter.branchFilter ||
    _vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ||
    _vm.Filter.StatusVerbose ||
    _vm.Filter.hasDateMismatch ||
    _vm.Filter.daysFilter ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.getTimeLineList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getTimeLineList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "10",
      "align": "center",
      "per-page": _vm.pagination.pageSize,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  })], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Days")]), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "options": _vm.dayOptions,
      "placeholder": "Select Days"
    },
    on: {
      "change": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1');
        _vm.updateDaysFilter()
      }
    },
    model: {
      value: (_vm.Filter.daysFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "daysFilter", $$v)
      },
      expression: "Filter.daysFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Booking NO Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Booking NO Filter",
      "id": "booking_number",
      "name": "booking_number",
      "autocomplete": "off",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.booking_number),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "booking_number", $$v)
      },
      expression: "Filter.booking_number"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Container No Filter",
      "id": "container_number",
      "name": "container_number",
      "autocomplete": "off",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.container_number),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "container_number", $$v)
      },
      expression: "Filter.container_number"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.slineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineFilter", $$v)
      },
      expression: "Filter.slineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientFilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "search_txt",
      "name": "search_txt",
      "autocomplete": "off",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.search_txt),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "search_txt", $$v)
      },
      expression: "Filter.search_txt"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status Verbose")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.StatusVerboseList,
      "option-value": "StatusVerboseVal",
      "option-text": "StatusVerboseTxt",
      "placeholder": "Select Status Verbose",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.StatusVerbose),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "StatusVerbose", $$v)
      },
      expression: "Filter.StatusVerbose"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Mismatch Actual/Initial")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.hasDateMismatchList,
      "option-value": "hasDateMismatchVal",
      "option-text": "hasDateMismatchTxt",
      "placeholder": "Select Mismatch Actual/Initial",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.hasDateMismatch),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "hasDateMismatch", $$v)
      },
      expression: "Filter.hasDateMismatch"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.getTimeLineTrackDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', _vm._l((_vm.getTimeLineList), function(item, index) {
    return _c('b-col', {
      key: index,
      staticClass: "mb-3",
      attrs: {
        "cols": "12"
      }
    }, [_c('b-card', {
      staticClass: "animated-border-card shadow-md rounded-xl border-light",
      style: ({
        background: 'linear-gradient(to right, #f8f9fa, #eef1f5)',
        transition: 'all 0.3s ease',
        border: '0.5px solid #dee2e6',
        padding: '0.25rem',
        fontsize: '8px'
      })
    }, [_c('b-row', {
      staticClass: "align-items-center mb-1",
      staticStyle: {
        "font-size": "0.675rem"
      }
    }, [_c('b-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('small', {
      staticClass: "text-primary"
    }, [_vm._v("\n                  #" + _vm._s(index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.pageSize) + "\n                ")])]), _vm._v(" "), _c('b-col', {
      staticClass: "text-right",
      attrs: {
        "cols": "6"
      }
    }, [_c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: ('track-' + index),
        expression: "'track-' + index"
      }],
      staticClass: "text-primary text-sm float-right",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "variant": "link",
        "size": "sm"
      }
    }, [_c('i', {
      staticClass: "bi bi-chevron-down small mr-1"
    }), _vm._v(" View Full Timeline\n                ")]), _vm._v(" "), _c('b-badge', {
      staticClass: "text-capitalize shadow-sm",
      attrs: {
        "variant": "info"
      }
    }, [_vm._v("\n                  " + _vm._s(item.StatusVerbose) + "\n                ")])], 1)], 1), _vm._v(" "), _c('b-row', {
      staticClass: "text-sm"
    }, [_c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('h6', {
      staticClass: "text-primary mb-1"
    }, [_c('i', {
      staticClass: "bi bi-journal-bookmark mr-1"
    }), _vm._v(" Booking\n                ")]), _vm._v(" "), _c('b', [_vm._v("Booking No:")]), _vm._v(" "), _c('span', {
      style: (item.subscription_id ? 'color:#007bff;font-weight:bold;cursor:pointer' : ''),
      on: {
        "click": function($event) {
          item.subscription_id ? _vm.goToSubscriptionPage(item) : ''
        }
      }
    }, [_vm._v("\n                  " + _vm._s(item.BookingNumber) + "\n                ")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Job No:")]), _vm._v(" " + _vm._s(item.JobNo)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Job Date:")]), _vm._v(" " + _vm._s(item.JobDate)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Raised By:")]), _vm._v(" " + _vm._s(item.RaisedBy)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Client:")]), _vm._v(" " + _vm._s(item.ClientName)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Sline:")]), _vm._v(" " + _vm._s(item.SlineName)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Mbl No:")]), _vm._v(" " + _vm._s(item.BlType) + " | " + _vm._s(item.MblNo)), _c('br'), _vm._v(" "), _c('b', [_vm._v("MBL Date:")]), _vm._v(" " + _vm._s(item.MblDate)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Mbl Release:")]), _vm._v(" " + _vm._s(item.MblReleaseDate)), _c('br'), _vm._v(" "), _c('b', [_vm._v("IncoTerm:")]), _vm._v(" " + _vm._s(item.IncoTerm)), _c('br'), _vm._v(" "), _c('b', [_vm._v("BrfNo:")]), _vm._v(" " + _vm._s(item.BrfNo)), _c('br'), _vm._v(" "), (_vm.tabName == 'Leg 1 Changed') ? _c('b', [_vm._v("\n                  Leg 1 Old → Current: " + _vm._s(item.old_leg1_vessel_name) + " → " + _vm._s(item.current_leg1_vessel_name))]) : _vm._e(), _vm._v(" "), (_vm.tabName == 'Leg 2 Changed') ? _c('b', [_vm._v("\n                  Leg 2 Old → Current: " + _vm._s(item.old_leg2_vessel_name) + " → " + _vm._s(item.current_leg2_vessel_name))]) : _vm._e(), _vm._v(" "), (_vm.tabName == 'SOB Changed') ? _c('b', [_vm._v("\n                  SOB Old → Current: " + _vm._s(item.old_SobPlanDetected) + " → " + _vm._s(item.current_SobPlanDetected)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.tabName.startsWith('SOB ')) ? _c('b', [_vm._v("\n                  SOB Planned Initial: " + _vm._s(item.old_SobPlanInitial) + " → " + _vm._s(item.current_SobPlanInitial)), _c('br'), _vm._v("\n                  SOB Planned Last: " + _vm._s(item.old_SobPlanLast) + " → " + _vm._s(item.current_SobPlanLast)), _c('br'), _vm._v("\n                  SOB Actual: " + _vm._s(item.old_SobPlanActual) + " → " + _vm._s(item.current_SobPlanActual)), _c('br'), _vm._v("\n                  SOB Detected: " + _vm._s(item.old_SobPlanDetected) + " → " + _vm._s(item.current_SobPlanDetected)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.tabName == 'POL Changed') ? _c('b', [_vm._v("\n                  POL Arrival Planned Initial: " + _vm._s(item.old_pol_arrival_planned_initial) + " → " + _vm._s(item.current_pol_arrival_planned_initial)), _c('br'), _vm._v("\n                  POL Arrival Actual: " + _vm._s(item.old_pol_arrival_actual) + " → " + _vm._s(item.current_pol_arrival_actual)), _c('br'), _vm._v("\n                  Days Diff: " + _vm._s(item.current_pol_arrival_days_diff) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tabName.startsWith('POL ') && _vm.tabName.includes('Arrival')) ? _c('b', [_vm._v("\n                  POL Arrival Planned Initial: " + _vm._s(item.old_pol_arrival_planned_initial) + " → " + _vm._s(item.current_pol_arrival_planned_initial)), _c('br'), _vm._v("\n                  POL Arrival Actual: " + _vm._s(item.old_pol_arrival_actual) + " → " + _vm._s(item.current_pol_arrival_actual)), _c('br'), _vm._v("\n                  Days Diff: " + _vm._s(item.current_pol_arrival_days_diff) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tabName.startsWith('POL ') && _vm.tabName.includes('Departure')) ? _c('b', [_vm._v("\n                  POL Departure Planned Initial: " + _vm._s(item.old_pol_departure_planned_initial) + " → " + _vm._s(item.current_pol_departure_planned_initial)), _c('br'), _vm._v("\n                  POL Departure Actual: " + _vm._s(item.old_pol_departure_actual) + " → " + _vm._s(item.current_pol_departure_actual)), _c('br'), _vm._v("\n                  Days Diff: " + _vm._s(item.current_pol_departure_days_diff) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tabName == 'POD Plan Changed') ? _c('b', [_vm._v("\n                  POD VSL Arrival Planned Initial: " + _vm._s(item.old_pod_vslarrival_planned_initial) + " → " + _vm._s(item.current_pod_vslarrival_planned_initial)), _c('br'), _vm._v("\n                  POD VSL Arrival Actual: " + _vm._s(item.old_pod_vslarrival_actual) + " → " + _vm._s(item.current_pod_vslarrival_actual)), _c('br'), _vm._v("\n                  Days Diff: " + _vm._s(item.current_pod_vslarrival_days_diff) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tabName == 'POD Departure Changed') ? _c('b', [_vm._v("\n                  POD Departure Planned Initial: " + _vm._s(item.old_pod_departure_planned_initial) + " → " + _vm._s(item.current_pod_departure_planned_initial)), _c('br'), _vm._v("\n                  POD Departure Actual: " + _vm._s(item.old_pod_departure_actual) + " → " + _vm._s(item.current_pod_departure_actual)), _c('br'), _vm._v("\n                  Days Diff: " + _vm._s(item.current_pod_departure_days_diff) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tabName.startsWith('POD ') && _vm.tabName.includes('Arrival')) ? _c('b', [_vm._v("\n                  POD Arrival Planned Initial: " + _vm._s(item.old_pod_arrival_planned_initial) + " → " + _vm._s(item.current_pod_arrival_planned_initial)), _c('br'), _vm._v("\n                  POD Arrival Actual: " + _vm._s(item.old_pod_arrival_actual) + " → " + _vm._s(item.current_pod_arrival_actual)), _c('br'), _vm._v("\n                  Days Diff: " + _vm._s(item.current_pod_arrival_days_diff) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tabName.startsWith('POD ') && _vm.tabName.includes('Departure')) ? _c('b', [_vm._v("\n                  POD Departure Planned Initial: " + _vm._s(item.old_pod_departure_planned_initial) + " → " + _vm._s(item.current_pod_departure_planned_initial)), _c('br'), _vm._v("\n                  POD Departure Actual: " + _vm._s(item.old_pod_departure_actual) + " → " + _vm._s(item.current_pod_departure_actual)), _c('br'), _vm._v("\n                  Days Diff: " + _vm._s(item.current_pod_departure_days_diff) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tabName == 'DLV Arrival') ? _c('b', [_vm._v("\n                  DLV Delivery Planned Initial: " + _vm._s(item.old_dlv_delivery_planned_initial) + " → " + _vm._s(item.current_dlv_delivery_planned_initial)), _c('br'), _vm._v("\n                  DLV Delivery Actual: " + _vm._s(item.old_dlv_delivery_actual) + " → " + _vm._s(item.current_dlv_delivery_actual)), _c('br'), _vm._v("\n                  Days Diff: " + _vm._s(item.current_dlv_delivery_days_diff) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tabName.startsWith('DLV ') && _vm.tabName.includes('Arrival')) ? _c('b', [_vm._v("\n                  DLV Arrival Planned Initial: " + _vm._s(item.old_dlv_arrival_planned_initial) + " → " + _vm._s(item.current_dlv_arrival_planned_initial)), _c('br'), _vm._v("\n                  DLV Arrival Actual: " + _vm._s(item.old_dlv_arrival_actual) + " → " + _vm._s(item.current_dlv_arrival_actual)), _c('br'), _vm._v("\n                  Days Diff: " + _vm._s(item.current_dlv_arrival_days_diff) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tabName == 'TSP4 Departure Changed') ? _c('b', [_vm._v("\n                  TSP4 VSL Departure Planned Initial: " + _vm._s(item.old_tsp4_vsldeparture_planned_initial) + " → " + _vm._s(item.current_tsp4_vsldeparture_planned_initial)), _c('br'), _vm._v("\n                  TSP4 VSL Departure Actual: " + _vm._s(item.old_tsp4_vsldeparture_actual) + " → " + _vm._s(item.current_tsp4_vsldeparture_actual)), _c('br'), _vm._v("\n                  Days Diff: " + _vm._s(item.current_tsp4_vsldeparture_days_diff) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tabName == 'TSP4 Arrival') ? _c('b', [_vm._v("\n                  TSP4 VSL Arrival Planned Initial: " + _vm._s(item.old_tsp4_vslarrival_planned_initial) + " → " + _vm._s(item.current_tsp4_vslarrival_planned_initial)), _c('br'), _vm._v("\n                  TSP4 VSL Arrival Actual: " + _vm._s(item.old_tsp4_vslarrival_actual) + " → " + _vm._s(item.current_tsp4_vslarrival_actual)), _c('br'), _vm._v("\n                  Days Diff: " + _vm._s(item.current_tsp4_vslarrival_days_diff) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tabName == 'TSP1 Changed') ? _c('b', [_vm._v("\n                  TSP1 VSL Departure Planned Initial: " + _vm._s(item.old_tsp1_vsldeparture_planned_initial) + " → " + _vm._s(item.current_tsp1_vsldeparture_planned_initial)), _c('br'), _vm._v("\n                  TSP1 VSL Departure Actual: " + _vm._s(item.old_tsp1_vsldeparture_actual) + " → " + _vm._s(item.current_tsp1_vsldeparture_actual)), _c('br'), _vm._v("\n                  Days Diff: " + _vm._s(item.current_tsp1_vsldeparture_days_diff) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tabName == 'TSP1 Arrival') ? _c('b', [_vm._v("\n                  TSP1 VSL Arrival Planned Initial: " + _vm._s(item.old_tsp1_vslarrival_planned_initial) + " → " + _vm._s(item.current_tsp1_vslarrival_planned_initial)), _c('br'), _vm._v("\n                  TSP1 VSL Arrival Actual: " + _vm._s(item.old_tsp1_vslarrival_actual) + " → " + _vm._s(item.current_tsp1_vslarrival_actual)), _c('br'), _vm._v("\n                  Days Diff: " + _vm._s(item.current_tsp1_vslarrival_days_diff) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tabName == 'TSP2 Departure Changed') ? _c('b', [_vm._v("\n                  TSP2 VSL Departure Planned Initial: " + _vm._s(item.old_tsp2_vsldeparture_planned_initial) + " → " + _vm._s(item.current_tsp2_vsldeparture_planned_initial)), _c('br'), _vm._v("\n                  TSP2 VSL Departure Actual: " + _vm._s(item.old_tsp2_vsldeparture_actual) + " → " + _vm._s(item.current_tsp2_vsldeparture_actual)), _c('br'), _vm._v("\n                  Days Diff: " + _vm._s(item.current_tsp2_vsldeparture_days_diff) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tabName == 'TSP2 Arrival') ? _c('b', [_vm._v("\n                  TSP2 VSL Arrival Planned Initial: " + _vm._s(item.old_tsp2_vslarrival_planned_initial) + " → " + _vm._s(item.current_tsp2_vslarrival_planned_initial)), _c('br'), _vm._v("\n                  TSP2 VSL Arrival Actual: " + _vm._s(item.old_tsp2_vslarrival_actual) + " → " + _vm._s(item.current_tsp2_vslarrival_actual)), _c('br'), _vm._v("\n                  Days Diff: " + _vm._s(item.current_tsp2_vslarrival_days_diff) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('h6', {
      staticClass: "text-success mb-1"
    }, [_c('i', {
      staticClass: "bi bi-geo-alt mr-1"
    }), _vm._v(" Location\n                ")]), _vm._v(" "), _c('b', [_vm._v("From:")]), _vm._v(" " + _vm._s(item.RaisedFrom)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Empty Pickup:")]), _vm._v(" " + _vm._s(item.EmptyPickupLoc)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Origin → POL:")]), _vm._v(" " + _vm._s(item.OriginLoc) + " → " + _vm._s(item.PolLoc)), _c('br'), _vm._v(" "), _c('b', [_vm._v("POD → DLV:")]), _vm._v(" " + _vm._s(item.PodLoc) + " → " + _vm._s(item.DlvLoc)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Empty Return:")]), _vm._v(" " + _vm._s(item.EmptyReturnLoc)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Tsp1 → Tsp2:")]), _vm._v(" " + _vm._s(item.Tsp1Loc) + " → " + _vm._s(item.Tsp2Loc)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Tsp3 → Tsp4:")]), _vm._v(" " + _vm._s(item.Tsp3Loc) + " → " + _vm._s(item.Tsp4Loc)), _c('br')]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('h6', {
      staticClass: "text-warning mb-1"
    }, [_c('i', {
      staticClass: "bi bi-box-seam mr-1"
    }), _vm._v(" Status\n                ")]), _vm._v(" "), _c('b', [_vm._v("Container:")]), _vm._v(" " + _vm._s(item.container_number)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Vessel 1 → Voyage 1:")]), _vm._v(" " + _vm._s(item.Vessel1) + " → " + _vm._s(item.Voyage1)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Vessel 2 → Voyage 2:")]), _vm._v(" " + _vm._s(item.Vessel2) + " → " + _vm._s(item.Voyage2)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Status Msg:")]), _vm._v(" " + _vm._s(item.EventMessage)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Status Verbose:")]), _vm._v(" " + _vm._s(item.StatusVerbose)), _c('br')]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('h6', {
      staticClass: "text-danger mb-1"
    }, [_c('i', {
      staticClass: "bi bi-flag-fill mr-1"
    }), _vm._v(" SOB\n                ")]), _vm._v(" "), _c('b', [_vm._v("Arrival Plan → Actual:")]), _vm._v(" " + _vm._s(item.SobPlanInitial) + " → " + _vm._s(item.PolPlanActual)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Departure Plan → Actual:")]), _vm._v(" " + _vm._s(item.SobPlanActual) + " → " + _vm._s(item.SobPlanDetected)), _c('br'), _vm._v(" "), _c('b', [_vm._v("SI:")]), _vm._v(" " + _vm._s(item.SiCB) + " → " + _vm._s(item.SiMain)), _c('br'), _vm._v(" "), _c('b', [_vm._v("VGM:")]), _vm._v(" " + _vm._s(item.VgmCb) + " → " + _vm._s(item.VgmMain)), _c('br'), _vm._v(" "), _c('b', [_vm._v("TR:")]), _vm._v(" " + _vm._s(item.TrCb) + " → " + _vm._s(item.TrMain)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Hand:")]), _vm._v(" " + _vm._s(item.HandoverCB) + " → " + _vm._s(item.HandoverMain)), _c('br')])], 1), _vm._v(" "), _c('b-collapse', {
      staticClass: "mt-2 ",
      attrs: {
        "id": 'track-' + index,
        "accordion": "track-accordion"
      }
    }, [_c('b-row', {
      staticClass: "text-sm g-2"
    }, [_c('b-col', {
      staticClass: "bg-light p-2 rounded border border-primary mb-1",
      attrs: {
        "md": "3"
      }
    }, [_c('h6', {
      staticClass: "text-primary"
    }, [_c('i', {
      staticClass: "bi bi-box-seam"
    }), _vm._v(" Empty Pickup")]), _vm._v(" "), _c('b', [_vm._v("Arrival Plan → Last:")]), _vm._v(" " + _vm._s(item.EmptyPickupPlanInitial) + " → " + _vm._s(item.EmptyPickupPlanLast)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Departure Actual:")]), _vm._v(" " + _vm._s(item.EmptyPickupPlanActual)), _c('br')]), _vm._v(" "), _c('b-col', {
      staticClass: "bg-light p-2 rounded border border-success mb-1",
      attrs: {
        "md": "3"
      }
    }, [_c('h6', {
      staticClass: "text-success"
    }, [_c('i', {
      staticClass: "bi bi-box-seam"
    }), _vm._v(" Origin")]), _vm._v(" "), _c('b', [_vm._v("Arrival Plan → Last:")]), _vm._v(" " + _vm._s(item.OriginPlanInitial) + " → " + _vm._s(item.OriginPlanLast)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Departure Actual:")]), _vm._v(" " + _vm._s(item.OriginPlanActual)), _c('br')]), _vm._v(" "), _c('b-col', {
      staticClass: "bg-light p-2 rounded border border-info mb-1",
      attrs: {
        "md": "3"
      }
    }, [_c('h6', {
      staticClass: "text-info"
    }, [_c('i', {
      staticClass: "bi bi-box-seam"
    }), _vm._v(" POL")]), _vm._v(" "), _c('b', [_vm._v("Arrival Plan → Last:")]), _vm._v(" " + _vm._s(item.PolPlanInitial) + " → " + _vm._s(item.PolPlanLast)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Departure Actual:")]), _vm._v(" " + _vm._s(item.PolPlanActual)), _c('br')]), _vm._v(" "), _c('b-col', {
      staticClass: "bg-light p-2 rounded border border-warning mb-1",
      attrs: {
        "md": "3"
      }
    }, [_c('h6', {
      staticClass: "text-warning"
    }, [_c('i', {
      staticClass: "bi bi-box-seam"
    }), _vm._v(" POD")]), _vm._v(" "), _c('b', [_vm._v("Arrival Plan → Actual:")]), _vm._v(" " + _vm._s(item.PodPlanInitial) + " → " + _vm._s(item.PodPlanActual)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Departure Plan → Actual:")]), _vm._v(" " + _vm._s(item.PodDepartureInitial) + " → " + _vm._s(item.PodDepartureActual)), _c('br')]), _vm._v(" "), _c('b-col', {
      staticClass: "bg-light p-2 rounded border border-danger mb-1",
      attrs: {
        "md": "3"
      }
    }, [_c('h6', {
      staticClass: "text-danger"
    }, [_c('i', {
      staticClass: "bi bi-box-seam"
    }), _vm._v(" TSP1")]), _vm._v(" "), _c('b', [_vm._v("Arrival Plan → Actual:")]), _vm._v(" " + _vm._s(item.Tsp1PlanInitial) + " → " + _vm._s(item.Tsp1PlanActual)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Departure Plan → Actual:")]), _vm._v(" " + _vm._s(item.Tsp1DepartureInitial) + " → " + _vm._s(item.Tsp1DepartureActual)), _c('br')]), _vm._v(" "), _c('b-col', {
      staticClass: "bg-light p-2 rounded border border-secondary mb-1",
      attrs: {
        "md": "3"
      }
    }, [_c('h6', {
      staticClass: "text-secondary"
    }, [_c('i', {
      staticClass: "bi bi-box-seam"
    }), _vm._v(" TSP2")]), _vm._v(" "), _c('b', [_vm._v("Arrival Plan → Actual:")]), _vm._v(" " + _vm._s(item.Tsp2PlanInitial) + " → " + _vm._s(item.Tsp2PlanActual)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Departure Plan → Actual:")]), _vm._v(" " + _vm._s(item.Tsp2DepartureInitial) + " → " + _vm._s(item.Tsp2DepartureActual)), _c('br')]), _vm._v(" "), _c('b-col', {
      staticClass: "bg-light p-2 rounded border border-dark mb-1",
      attrs: {
        "md": "3"
      }
    }, [_c('h6', {
      staticClass: "text-dark"
    }, [_c('i', {
      staticClass: "bi bi-box-seam"
    }), _vm._v(" TSP3")]), _vm._v(" "), _c('b', [_vm._v("Arrival Plan → Actual:")]), _vm._v(" " + _vm._s(item.Tsp3PlanInitial) + " → " + _vm._s(item.Tsp3PlanActual)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Departure Plan → Actual:")]), _vm._v(" " + _vm._s(item.Tsp3DepartureInitial) + " → " + _vm._s(item.Tsp3DepartureActual)), _c('br')]), _vm._v(" "), _c('b-col', {
      staticClass: "bg-light p-2 rounded border border-primary mb-1",
      attrs: {
        "md": "3"
      }
    }, [_c('h6', {
      staticClass: "text-primary"
    }, [_c('i', {
      staticClass: "bi bi-box-seam"
    }), _vm._v(" TSP4")]), _vm._v(" "), _c('b', [_vm._v("Arrival Plan → Actual:")]), _vm._v(" " + _vm._s(item.Tsp4PlanInitial) + " → " + _vm._s(item.Tsp4PlanActual)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Departure Plan → Actual:")]), _vm._v(" " + _vm._s(item.Tsp4DepartureInitial) + " → " + _vm._s(item.Tsp4DepartureActual)), _c('br')]), _vm._v(" "), _c('b-col', {
      staticClass: "bg-light p-2 rounded border border-success mb-1",
      attrs: {
        "md": "3"
      }
    }, [_c('h6', {
      staticClass: "text-success"
    }, [_c('i', {
      staticClass: "bi bi-box-seam"
    }), _vm._v(" Empty Return")]), _vm._v(" "), _c('b', [_vm._v("Arrival Plan → Last:")]), _vm._v(" " + _vm._s(item.EmptyReturnPlanInitial) + " → " + _vm._s(item.EmptyReturnPlanLast)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Departure Actual:")]), _vm._v(" " + _vm._s(item.EmptyReturnPlanActual)), _c('br')]), _vm._v(" "), _c('b-col', {
      staticClass: "bg-light p-2 rounded border border-info mb-1",
      attrs: {
        "md": "3"
      }
    }, [_c('h6', {
      staticClass: "text-info"
    }, [_c('i', {
      staticClass: "bi bi-box-seam"
    }), _vm._v(" Pridel Prediction")])])], 1)], 1)], 1)], 1)
  })), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "10",
      "align": "center",
      "per-page": _vm.pagination.pageSize,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bfced69","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/tracking/milestoneTrack.vue
// module id = 2486
// module chunks = 0